import { render, staticRenderFns } from "./index.vue?vue&type=template&id=25a1175c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=25a1175c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a1175c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseUiBreadcrumbBanner: require('/var/www/homolog.intelli.com.br/intelli.owinteractive.com/components/base/ui/BreadcrumbBanner.vue').default,BaseUiMultiselect: require('/var/www/homolog.intelli.com.br/intelli.owinteractive.com/components/base/ui/Multiselect.vue').default,BaseUiFileUploader: require('/var/www/homolog.intelli.com.br/intelli.owinteractive.com/components/base/ui/FileUploader.vue').default})
